import { Link, useLocation } from "react-router-dom";
import { useGo } from "@/lib/nav";

// Real hrefs allow crawling, keyboard navigation and open-in-new-tab, while retaining
// the existing smooth-scroll behavior of home-section links.
export const CrawlableLink = ({ to, onNavigate, children, ...props }) => {
  const { pathname } = useLocation();
  const go = useGo();
  return <Link {...props} to={to.startsWith("#") ? `/${to}` : to} onClick={(event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    onNavigate?.();
    if (to.startsWith("#") && pathname === "/") { event.preventDefault(); go(to); }
  }}>{children}</Link>;
};